import { SDKContext, type SDKContextProps } from '@/sdk/contexts/SDKContext';
import { useContext } from 'react';

export const useSDKContext = (): SDKContextProps => useContext(SDKContext);
